import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconRulerMeasure } from "@tabler/icons-react";

export const TiposMedidaRopaIcon = IconRulerMeasure;
export const TiposMedidaRopaHelpText = '* Aquí puede ver la lista de tipos de medidas.';


export class catTiposMedidasRopa extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposMedidasRopa";
        this.def.columns.c_category_id.defaultValue = "TiposMedidasRopa";
        this.Title = "Medidas Ropa";
        this.Icon = TiposMedidaRopaIcon;
        this.HelpText = TiposMedidaRopaHelpText;
    }
}